import { BaseProduct } from 'server/services/recommendation';

function createRecsWindowObj(products: BaseProduct[]): void {
  if (!products || products.length === 0) return;
  const atbRecs: appATBProduct[] = products.map((product) => ({
    url: `${window.location.origin}${product.url}`,
    clickUrl: `${window.location.origin}${product.url}`,
    brand: product.brand || null,
    description: product.title,
    price: {
      wasPrice: product?.price?.previous || null,
      wasPriceTo: null,
      price: product?.price?.current || null,
      priceTo: null,
    },
    imageUrl: product.image.url,
  }));
  window.atbRecs = atbRecs;
}

export default createRecsWindowObj;
